export default __webpack_public_path__ + "static/media/premium-time-plan.3dd4ef80.svg";